import React from "react";
import ReactDOM from "react-dom";
import { Catalog, pageLoader } from "catalog";

const configuration = {
  title: 'Businessplan',
  styles: ['/styles.css'],
  logoSrc: '/logo.svg',
  theme: {
    fontFamily: 'Roboto, sans-serif',
    brandColor: '#0cf',
    linkColor: '#0cf',
    sidebarColorText: "#252525",
    sidebarColorTextActive: '#0cf',
    pageHeadingBackground: "#252525",
    pageHeadingTextColor: "#fff",
    navBarTextColor: '#252525'
  }
}

const pages = [
  {
    path: "/",
    title: "Willkommen",
    content: pageLoader(() => import("./pages/start.md"))
  },
  {
    path: "/executive-summary",
    title: "Executive Summary",
    content: pageLoader(() => import("./pages/1-executive-summary/index.md"))
  },
  {
    title: 'Services',
    pages: [
      {
        path: '/web',
        title: 'Web',
        content: pageLoader(() => import("./pages/2-services/web.md"))
      },
      {
        path: '/growth',
        title: 'Growth',
        content: pageLoader(() => import("./pages/2-services/growth.md"))
      },
      {
        path: '/innovation',
        title: 'Innovation',
        content: pageLoader(() => import("./pages/2-services/innovation.md"))
      }
    ]
  },
  {
    path: "/marktanalyse",
    title: "Markanalyse",
    content: pageLoader(() => import("./pages/start.md"))
  },
  {
    path: "/wettbewerb",
    title: "Wettbewerb",
    content: pageLoader(() => import("./pages/start.md"))
  },
  {
    path: "/team",
    title: "Team",
    content: pageLoader(() => import("./pages/5-team/index.md"))
  },
  {
    path: "/organisation",
    title: "Organisation",
    content: pageLoader(() => import("./pages/start.md"))
  },
  {
    path: "/geschichte",
    title: "Was bisher geschah",
    content: pageLoader(() => import("./pages/7-geschichte/index"))
  },
  {
    path: "/planung",
    title: "Planung",
    content: pageLoader(() => import("./pages/start.md"))
  },
];

ReactDOM.render(
  <Catalog
    title={configuration.title}
    logoSrc={configuration.logoSrc}
    styles={configuration.styles}
    theme={configuration.theme}
    useBrowserHistory={true}
    pages={pages} />,
  document.getElementById("catalog")
);



// WEBPACK FOOTER //
// ./catalog/index.js